/**
 * 微信公众号绑定账号页面
 * 2020-10-23 wuw
 */
import React from 'react';


import { Button } from 'antd-mobile';

import loginbg from '../../../style/img/loginbg.png'
import logo from '../../../style/img/logo-min1.png'


import http from "../../../axios/wechatHttp";

class UserInfo extends React.Component {

    state = {
        userInfo: {}
    }

    componentDidMount() {
        this.loadUserInfo();
    }

    //加载用户信息
    loadUserInfo = () => {
        http.post({
            url: "/auth/findUserInfo",
            success: (res) => {
                this.setState({ userInfo: res });
            }
        });
    }

    //注销
    logout = () => {
        http.post({
            url: '/common/unbindWxId',
            data: {
                wxApp: "offiaccount"
            },
            success: (data) => {
                sessionStorage.removeItem("loginStatus");
                window.location.href = '/wx/console/login';
            }
        });
    }



    render() {
        return <div>
            <div className="wxloginBanner">
                <div className="wxloginBannerbox">
                    <img src={loginbg} alt="" />
                    <span className="wxloginMask"></span>
                </div>
                <div className="wxlogin-logo">
                    <img src={logo} alt=""></img>
                </div>
                <div className="wxlogin-logo">
                    <img src={logo} alt=""></img>
                </div>
            </div>
            <div style={{ width: '100%', padding: '20px', textAlign: "center" }}>
                您已绑定账号：{this.state.userInfo.username}
            </div>
            <div style={{ width: '100%', padding: '20px' }}>
                <Button type="warning" onClick={this.logout}>注销帐号</Button>
            </div>
        </div>
    };
}

export default UserInfo;